import mitt from 'mitt'

// 创建事件总线实例
export const eventBus = mitt()